import { render, staticRenderFns } from "./HomepageTile.vue?vue&type=template&id=61a6b166&scoped=true"
import script from "./HomepageTile.vue?vue&type=script&lang=js"
export * from "./HomepageTile.vue?vue&type=script&lang=js"
import style0 from "./HomepageTile.vue?vue&type=style&index=0&id=61a6b166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a6b166",
  null
  
)

export default component.exports